import React, { useState } from 'react'
import PropTypes from 'prop-types'
import _, { isEmpty } from 'lodash'
import { Button, Col, Form, Icon, Input, Modal, Radio, Row, Upload } from 'antd'
import { ButtonEx } from '../../../../../styles/button.style'
import { useDeepEffect } from '../../../../../utils/hooks'

const UpdateMinQuantityForm = (props) => {
  const { visibleMin, onOkMin, onCancelMin, formDataMin, form } = props
  const { getFieldDecorator, validateFields, setFieldsValue } = form

  useDeepEffect(() => {
    if (!isEmpty(formDataMin)) {
      setFieldsValue({
        minQuantity: formDataMin.minQuantity
      })
    }

    return () => {
      form.resetFields()
    }
  }, [formDataMin])

  function onSubmit(e) {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        const data = {
          minQuantity: values.minQuantity,
        }
        if (!_.isEmpty(formDataMin)) {
          data.id = formDataMin.id
        }
        onOkMin(data)
      }
    })
  }
  return (
    <Modal
      title='Update MinQuantity'
      visible={visibleMin}
      footer={null}
      onCancel={onCancelMin}>
      <Form form={form} onSubmit={onSubmit} layout="vertical">
        <Form.Item label="MinQuantity">
          {getFieldDecorator(`minQuantity`, {
            rules: [
              {
                required: true,
                message: 'กรุณาเลือก'
              }
            ]
          })(
            <Radio.Group>
              <Radio value='NO_LIMIT'>ไม่จำกัด</Radio>
              <Radio value='UNIT_10'>{'>'} 10</Radio>
              <Radio value='UNIT_100'>{'>'} 100</Radio>
              <Radio value='UNIT_1000'>{'>'} 1000</Radio>
            </Radio.Group>
          )}
        </Form.Item>
        <Row type="flex" gutter={8} justify="end">
          <Col>
            <Button onClick={() => onCancelMin()}>ยกเลิก</Button>
          </Col>
          <Col>
            <ButtonEx color="#6ebf4b" type="primary" htmlType="submit">
              บันทึก
            </ButtonEx>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}

UpdateMinQuantityForm.propTypes = {
  form: PropTypes.any,
  visible: PropTypes.bool.isRequired,
  formData: PropTypes.object.isRequired,
  onOk: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
}

const WrappedUpdateMinQuantityForm = Form.create({ name: 'UpdateMinQuantityForm' })(
  UpdateMinQuantityForm
)
export default WrappedUpdateMinQuantityForm



// WEBPACK FOOTER //
// ./src/pages/Heroes/components/HeroProducts/UpdateMinQuantity/index.js